import { EmployeeAvatar } from "@/components/employee/EmployeeAvatar.tsx";
import { NotificationCount } from "@/components/notification-count/NotificationCount.tsx";
import { useBlogMyChannels, useBlogMyChannelsUnreadCount } from "@/queries/blog.query.ts";
import { useEmployeeToday } from "@/queries/employees/use-employee-today.query.ts";
import { useEmployeeMe } from "@/queries/employees/use-employees.query.ts";
import { Avatar, Box, FontAwesomeIcon, LinkTo, Skeleton, Stack, Text } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { twMerge } from "tailwind-merge";

export function BlogChannelsList() {
  const { channel_id } = useParams();
  const channelId = channel_id ? Number(channel_id) : undefined;
  const { data: employeeMe } = useEmployeeMe();
  const { data: channels, isLoading } = useBlogMyChannels();
  const { t } = useTranslation();
  const { data: myChannelsUnreadCount } = useBlogMyChannelsUnreadCount();
  const { data: todayResult } = useEmployeeToday();
  const isMentionPage = new RegExp("/news/mentions", "gi").test(location.pathname);

  return (
    <Stack gap={"md"} direction={"horizontal"} justify={"center"} className={"flex-wrap"}>
      <LinkTo to={`/news`} className={"no-underline"}>
        <Stack gap={"xs"} className={"w-24 cursor-pointer no-underline"}>
          <Stack items={"center"}>
            <Box
              className={twMerge(
                "w-12 h-12 rounded-md transition-all duration-200 relative",
                channelId || isMentionPage ? "bg-dark/5 hover:bg-dark/10" : "bg-dark",
                employeeMe?.avatar_url && (channelId || isMentionPage) ? "opacity-50" : ""
              )}
            >
              {(myChannelsUnreadCount?.unread_post_count ?? 0) > 0 && (
                <Box className={"absolute -top-1 -right-1 z-1"}>
                  <NotificationCount
                    count={myChannelsUnreadCount?.unread_post_count ?? 0}
                    variant={"new"}
                    size={"sm"}
                  />
                </Box>
              )}
              {employeeMe && (
                <EmployeeAvatar
                  employee={employeeMe}
                  // acronymClassName={channelId || isMentionPage ? "" : "text-light/80"}
                  size={"lg"}
                  variant={"plain"}
                />
              )}
            </Box>
          </Stack>
          <Text className={"whitespace-nowrap text-ellipsis overflow-hidden text-center"}>
            {t("blog:my_feed")}
          </Text>
        </Stack>
      </LinkTo>
      {todayResult?.total_mentions_count && todayResult.total_mentions_count > 0 ? (
        <LinkTo to={`/news/mentions`} className={"no-underline"}>
          <Stack gap={"xs"} className={"w-24 cursor-pointer no-underline"}>
            <Stack items={"center"}>
              <Box
                className={twMerge(
                  "w-12 h-12 rounded-md transition-all duration-200 relative",
                  !isMentionPage ? "bg-dark/5 hover:bg-dark/10" : "bg-dark"
                )}
              >
                {(todayResult?.unread_mentions_count ?? 0) > 0 && (
                  <Box className={"absolute -top-1 -right-1"}>
                    <NotificationCount
                      count={todayResult?.unread_mentions_count ?? 0}
                      variant={"new"}
                      size={"sm"}
                    />
                  </Box>
                )}

                <Avatar
                  size="lg"
                  icon={
                    <FontAwesomeIcon
                      icon={"fa-light fa-at"}
                      className={!isMentionPage ? "" : "text-light/80"}
                    />
                  }
                />
              </Box>
            </Stack>
            <Text className={"whitespace-nowrap text-ellipsis overflow-hidden text-center"}>
              {t("core:mentions")}
            </Text>
          </Stack>
        </LinkTo>
      ) : (
        <></>
      )}
      {isLoading && (
        <Stack gap={"xs"} className={"w-24 cursor-pointer"}>
          <Stack items={"center"}>
            <Skeleton className={"w-12 h-12 rounded-sm"} />
          </Stack>
          <Text className={"whitespace-nowrap text-ellipsis overflow-hidden text-center"}>
            <Skeleton className={"w-10 h-5 m-auto rounded-sm"} />
          </Text>
        </Stack>
      )}
      {channels?.map((channel) => (
        <LinkTo to={`/news/${channel.id}`} key={`channel-${channel.id}`} className={"no-underline"}>
          <Stack gap={"xs"} className={"w-24 cursor-pointer no-underline"}>
            <Stack items={"center"}>
              <Box
                className={twMerge(
                  "w-12 h-12 rounded-sm transition-all duration-200",
                  channelId == channel.id ? "bg-dark" : "bg-dark/5 hover:bg-dark/10"
                )}
              >
                <Avatar size="lg" emoji={channel.emoji} />
              </Box>
            </Stack>
            <Text
              className={twMerge(
                "whitespace-nowrap text-ellipsis overflow-hidden text-center",
                myChannelsUnreadCount?.unread_channel_ids.includes(channel.id)
                  ? "font-semibold"
                  : ""
              )}
            >
              {channel.title}
            </Text>
          </Stack>
        </LinkTo>
      ))}
    </Stack>
  );
}
